import React from 'react';
import { motion } from 'framer-motion';
import { Euro } from 'lucide-react';

interface PriceSelectorProps {
  value: number;
  onChange: (value: number) => void;
}

export const PriceSelector: React.FC<PriceSelectorProps> = ({ value, onChange }) => {
  const priceOptions = [5, 10, 15, 20, 25, 30];

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <Euro className="text-orange-500" size={20} />
        <h4 className="font-medium">Presupuesto máximo por plato</h4>
      </div>

      <div className="grid grid-cols-3 gap-2">
        {priceOptions.map((price) => (
          <motion.button
            key={price}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => onChange(price)}
            className={`py-3 px-4 rounded-lg transition-all ${
              value === price
                ? 'bg-orange-500 text-white shadow-md'
                : 'bg-orange-100 text-gray-700 hover:bg-orange-200'
            } flex items-center justify-center gap-1`}
          >
            <span className="font-medium">{price}</span>
            <span className="text-sm">€</span>
          </motion.button>
        ))}
      </div>

      <p className="text-sm text-gray-500 mt-3">
        El menú se ajustará a este presupuesto por cada plato
      </p>
    </div>
  );
};